import { render, staticRenderFns } from "./AvChartRange.vue?vue&type=template&id=2cbc622f"
import script from "./AvChartRange.vue?vue&type=script&lang=ts"
export * from "./AvChartRange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports